import { CartArticle, CartArticleOption, MoneyValue } from 'src/models/order.models';

export type ReceiptPayload = ReceiptPayloadArticle[];

export interface ReceiptPayloadArticle extends Omit<CartArticle, 'ArticleOptions'> {
  ArticleOptions: ReceiptPayloadArticleOption[];
}

export interface ReceiptPayloadArticleOption extends CartArticleOption {
  GrossPriceInclVat?: number;
}

export class ReceiptPayloadBuilder {
  static build(articleList: CartArticle[]): ReceiptPayload {
    return articleList.map((article) => ({
      ...article,
      ArticleOptions: article.ArticleOptions.map((option) => this.buildOption(option)),
    }));
  }

  private static buildOption(option: CartArticleOption): ReceiptPayloadArticleOption {
    const payloadOption: ReceiptPayloadArticleOption = { ...option };

    if (payloadOption.GrossPriceInclVat !== undefined) {
      payloadOption.GrossPriceInclVat = this.normalizeGrossPriceInclVat(
        payloadOption.GrossPriceInclVat
      );
    }

    return payloadOption;
  }

  private static normalizeGrossPriceInclVat(price: MoneyValue): number {
    if (typeof price === 'number') {
      return this.numberToCents(price);
    }

    const normalizedPrice = price.replace(',', '.');
    const numericPrice = Number(normalizedPrice);

    if (!Number.isFinite(numericPrice)) {
      return 0;
    }

    if (normalizedPrice.includes('.')) {
      return Math.round(numericPrice * 100);
    }

    return this.numberToCents(numericPrice);
  }

  private static numberToCents(price: number): number {
    if (!Number.isInteger(price)) {
      return Math.round(price * 100);
    }

    if (price >= 10000 && price % 100 === 0) {
      return Math.round(price / 100);
    }

    return price;
  }
}
